<template>
    <div class="timer" :class="state">
        <div
            class="bar"
            :style="{ width: (seconds / total) * 100 + '%' }"
        ></div>
        <span>{{ time }}</span>
    </div>
</template>

<script>
export default {
    name: "Timer",
    props: ["seconds", "state", "total", "theme"],
    computed: {
        time: function() {
            let currentSeconds = this.seconds;
            let secondsLeft = currentSeconds;

            let hh;
            let mm;
            let ss;

            if (currentSeconds >= 3600) {
                hh = Math.floor(currentSeconds / 3600);
                secondsLeft = currentSeconds - 3600 * hh;
            }

            mm = 0;
            if (secondsLeft >= 60) mm = Math.floor(secondsLeft / 60);
            secondsLeft = secondsLeft - 60 * mm;

            ss = secondsLeft;

            if (mm < 10) mm = "0" + mm;
            if (ss < 10) ss = "0" + ss;

            if (hh) {
                return `${hh}:${mm}:${ss}`;
            } else if (currentSeconds == 0) {
                return `Time's up!`;
            } else {
                return `${mm}:${ss}`;
            }
        },
        percentage: function() {
            return Math.round((this.seconds / this.total) * 100);
        },
    },
};
</script>

<style lang="scss" scoped>
.timer {
    background: rgb(32, 30, 36);
    width: 180px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    font-weight: 500;
    position: relative;
    border-radius: 0 0 5px 5px;
    padding-top: 5px;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 0.05em;

    .bar {
        position: absolute;
        top: 0;
        left: 0;
        height: 7px;
        background: #d81e5b;
        transition: all 1s linear;
    }

    &.v-enter-active {
        animation: slideIn 1s ease-in-out;
    }

    &.v-leave-active {
        animation: slideIn 1s ease-in-out reverse;
    }

    // &.inactive {
    // }

    // &.active {
    // }

    &.ended {
        color: rgba(255, 255, 255, 0.2);
    }

    @keyframes slideIn {
        from {
            transform: translateY(-100%);
        }

        to {
            transform: translateY(0);
        }
    }

    @keyframes ended {
        0% {
            background: #fff;
        }

        50% {
            background: rgb(223, 129, 129);
        }

        100% {
            background: #fff;
        }
    }
}
</style>
